/**
 * @generated SignedSource<<6f8fac148313e50a2a47839f6fce409e>>
 * @relayHash fd1963a9d2faefb7e31ad7e80c7ff686
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 8fb85cfc50d17c92cb1806272faa77a6beba4ed8917f6a91ae784e3059fca725

import type { ConcreteRequest } from 'relay-runtime';
export type PersistentInviteEligibleQuery$variables = {
  skipLicenseQuery: boolean;
  skipSpaceQuery: boolean;
  spaceKey?: string | null;
};
export type PersistentInviteEligibleQuery$data = {
  readonly license?: {
    readonly licenseConsumingUserCount: number;
    readonly trialEndDate: string | null;
  } | null;
  readonly space?: {
    readonly currentUser: {
      readonly isAnonymouslyAuthorized: boolean;
    };
    readonly id: string | null;
  } | null;
};
export type PersistentInviteEligibleQuery = {
  response: PersistentInviteEligibleQuery$data;
  variables: PersistentInviteEligibleQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "skipLicenseQuery"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "skipSpaceQuery"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "spaceKey"
},
v3 = [
  {
    "condition": "skipSpaceQuery",
    "kind": "Condition",
    "passingValue": false,
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "key",
            "variableName": "spaceKey"
          }
        ],
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "id"
          },
          {
            "concreteType": "SpaceUserMetadata",
            "kind": "LinkedField",
            "name": "currentUser",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "isAnonymouslyAuthorized"
              }
            ]
          }
        ]
      }
    ]
  },
  {
    "condition": "skipLicenseQuery",
    "kind": "Condition",
    "passingValue": false,
    "selections": [
      {
        "concreteType": "License",
        "kind": "LinkedField",
        "name": "license",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "licenseConsumingUserCount"
          },
          {
            "kind": "ScalarField",
            "name": "trialEndDate"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "PersistentInviteEligibleQuery",
    "selections": (v3/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "PersistentInviteEligibleQuery",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "fd1963a9d2faefb7e31ad7e80c7ff686",
    "id": "8fb85cfc50d17c92cb1806272faa77a6beba4ed8917f6a91ae784e3059fca725",
    "metadata": {},
    "name": "PersistentInviteEligibleQuery",
    "operationKind": "query",
    "text": "query PersistentInviteEligibleQuery($spaceKey:String,$skipLicenseQuery:Boolean!,$skipSpaceQuery:Boolean!){space(key:$spaceKey)@skip(if:$skipSpaceQuery){id,currentUser{isAnonymouslyAuthorized}},license@skip(if:$skipLicenseQuery){licenseConsumingUserCount,trialEndDate}}"
  }
};
})();

(node as any).hash = "364b36bbc5d65271345dded2654a0688";

export default node;
